<template>
    <div>
        <el-row style="margin-bottom:10px;">
            <el-col :span="4">
                <el-select v-if="theProjectId == 0" v-model="form.projectId" @change="theProjectAllChange" size="small"
                    filterable clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>


            </el-col>
            <el-col :span="10" class='flex'>
                <el-select v-model="getUserVisitorBuildingList_data.yuvbType" v-change.getUserVisitorBuildingList
                    size="small" filterable clearable>
                    <el-option label="官方" :value="1">
                    </el-option>
                    <el-option label="非官方" :value="2">
                    </el-option>
                </el-select>
                <el-select v-model='getUserVisitorBuildingList_data.yuvbcId' clearable v-change.getUserVisitorBuildingList size="small" filterable>
                    <el-option v-for="item in getUserVisitorBuildingClassList_data.data || []" :key="item.yuvbcId"
                        :label="item.yuvbcName" :value="item.yuvbcId">
                    </el-option>
                </el-select>
                <el-input v-model="getUserVisitorBuildingList_data.yuvbName" placeholder="请输入楼宇名" clearable size='small'
                    style="max-width:380px;" />
                <el-button v-click.getUserVisitorBuildingList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="10">
                <el-button v-if="addUserVisitorBuilding" @click="$form('addUserVisitorBuilding')" size='small'
                    type="primary" style="float:right" icon='el-icon-circle-plus'>添加楼宇
                </el-button>
                <el-button v-if="addUserVisitorBuilding" @click=" $form('addMultiUsersAll'), tabledataAll = [], row = {}"
                    size='small' type="primary" style="float:right;margin-right: 20px;" icon='el-icon-circle-plus'>批量导入楼宇
                </el-button>
                <el-dropdown size='small' split-button type="warning" style="margin-left: 10px;width: 100px;" @click="Out()"
                    @command="Out">
                    导出
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item style="background-color: #E6A23C;color: white;"
                            command="1">导出全部</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getUserVisitorBuildingList' api='getUserVisitorBuildingList ::yuvbId'
            xupdateapi='updateUserVisitorBuilding' :height="H - 165" ref="getUserVisitorBuildingListTable">
        </mytable>

        <myform :viewobj='{
            addUserVisitorBuilding: ["新增楼宇信息", "el-icon-circle-plus"],
            updateUserVisitorBuilding: ["修改楼宇信息", "el-icon-edit-outline"],
            $succeed$: getUserVisitorBuildingList
        }' @close='$form("addUserVisitorBuilding", "reset")' @confirm='myform'>
            <template v-slot:yuvpId="{ Myformdata }">
                <el-select v-model='Myformdata.yuvpId' clearable filterable>
                    <el-option v-for="item in getUserVisitorPropertyList_data.data || []" :key="item.yuvpId"
                        :label="item.yuvpName" :value="item.yuvpId">
                    </el-option>
                </el-select>
            </template>
            <template v-slot:yuvbcId="{ Myformdata }">
                <el-select v-model='Myformdata.yuvbcId' clearable>
                    <el-option v-for="item in getUserVisitorBuildingClassList_data.data || []" :key="item.yuvbcId"
                        :label="item.yuvbcName" :value="item.yuvbcId">
                    </el-option>
                </el-select>
            </template>
            <template v-for="item in DiyList.visitorCustomizeBuilding">
                <div style="display: flex;margin: 20px 0;">
                    <div style="margin:0 20px;width: 20%;text-align: right;"><span style="color: red;"
                            v-if="item.yuvceNecessary == 2">*</span> {{ item.yuvceLabel }}</div>
                    <div style="width: 80%;">
                        <el-input v-model="formBuilding[item.yuvceKey]" style="width: 100%;" size="small"
                            @input="$forceUpdate()"></el-input>
                    </div>
                </div>
            </template>
            <hide slot='yuvbId' />
        </myform>
        <myform view.addMultiUsersAll="批量导入楼宇" @close='$form("addMultiUsersAll", "hide")'>
            <el-row>
                <el-col :span="4" style="min-width:100px;">
                    <el-button type="primary" @click="toDownExcel">下载<i
                            class="el-icon-download el-icon--right"></i></el-button>
                </el-col>
                <el-col :span="20">
                    <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
                        :on-change="onChangeContent">
                        <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
                <el-table-column prop="status" label="状态" width="120">
                </el-table-column>
                <el-table-column prop="statusMsg" label="原因" width="120">
                </el-table-column>
                <el-table-column prop="yuvbcName" label="楼宇分类">
                </el-table-column>
                <el-table-column prop="yuvbName" label="楼宇">
                </el-table-column>
                <el-table-column prop="yuvpName" label="物业">
                </el-table-column>
                <el-table-column prop="yuvbAddress" label="楼宇地址">
                </el-table-column>
                <el-table-column prop="yuvbFloor" label="楼宇层数">
                </el-table-column>

            </el-table>
            <div style="width:100%; margin: 60px auto 20px;text-align: right;">
                <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                <el-button type="success" @click="bulkImportClick">确定导入</el-button>
            </div>
        </myform>
        <myform view.getUserVisitorBuildingDetails='详情' @opened="">

            <el-descriptions v-if="getUserVisitorBuildingDetails_data.data" :column="1" border :labelStyle="{
                color: '#409EFF',
                textAlign: 'center',
                width: '20%',
                fontSize: '12px'
            }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }">
                <el-descriptions-item label="楼宇名称">{{ getUserVisitorBuildingDetails_data.data.yuvbName
                }}</el-descriptions-item>
                <el-descriptions-item label="楼宇类型">{{ getUserVisitorBuildingDetails_data.data.yuvbcName
                }}</el-descriptions-item>
                <template v-for="(item, index) in DiyList.visitorCustomizeBuilding">
                    <el-descriptions-item :label="item.yuvceLabel">{{ formDetail[item.yuvceKey] }}</el-descriptions-item>
                </template>
            </el-descriptions>
            <hide slot='yuvbId' />
        </myform>
    </div>
</template>
  
<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            baseUrl: $Api.baseUrl_online,
            formDetail: {},
            formBuilding: {},
            tabledata: [],
            tabledataAll: [],
            DiyList: [],
            from: {
                projectId: null,
            },
            attrId: null,
            theHasKey: 1,
            tableColums_getUserVisitorBuildingList: {
                $selection: true,
                yuvpName: '物业名称',
                yuvbName: '楼宇名称',
                yuvbcName: '楼宇类型',


                createtime: '创建时间',

                $operation: [
                    '操作', 200,
                    this.updateUserVisitorBuilding && `@text: 编辑#success
             @click:Edit($row)
            `,
                    this.deleteUserVisitorBuilding && `@text: 删除#danger
             @click: _confirm('确定要删除该楼宇吗?')
                     .trigger('deleteUserVisitorBuilding',{yuvbIds:$row.yuvbId})
                     .trigger('getUserVisitorBuildingList')
            `,
                    this.getUserVisitorBuildingDetails && `@text: 详情#success
             @click:Detail($row)
            `,
                ],

            },

        };
    },

    watch: {

    },

    methods: {
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(e) {
           
            // if(!this.thepvcId){
            //   this.$message({message: '请先选择拜访分类在导出', type: 'warning' });
            //   return;
            // }
            if (e) {
                const bulkdata = {
                    projectId: this.theProjectId,
                    yuvbcId:this.getUserVisitorBuildingList_data.yuvbcId,
                    yuvbType:this.getUserVisitorBuildingList_data.yuvbType,
                    yuvbcId:this.getUserVisitorBuildingList_data.yuvbcId,
                    yuvbName:this.getUserVisitorBuildingList_data.yuvbName,
                    exportType: 1,
                    
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: that.baseUrl + '/opportunity/user-visitor-building/exportUserVisitorBuilding',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'token': A.local('$Usertoken'),
                        'projectId': +A.local('$projectId'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loading.close();
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '楼宇.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });
                       
                    }
                })
            } else {
                const selection = Object.keys(this.$refs.getUserVisitorBuildingListTable.$MyTableCache);
                if (selection.length === 0) return alertWarn('请选择您要导出的数据！');

                console.log(selection.join());
                const bulkdata = {
                    projectId: this.theProjectId,
                    yuvbcId:this.getUserVisitorBuildingList_data.yuvbcId,
                    yuvbType:this.getUserVisitorBuildingList_data.yuvbType,
                    yuvbcId:this.getUserVisitorBuildingList_data.yuvbcId,
                    yuvbName:this.getUserVisitorBuildingList_data.yuvbName,
                    exportType: 2,
                   
                    yuvbIds: selection.join()
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: that.baseUrl + '/opportunity/user-visitor-building/exportUserVisitorBuilding',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'token': A.local('$Usertoken'),
                        'projectId': +A.local('$projectId'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loading.close();
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '楼宇.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });
                        that.BulkClose()
                    }
                })
            }
        },
        Detail(row) {
            this.getUserVisitorBuildingDetails({ yuvbId: row.yuvbId }).result(res => {
                const data = res.data.data;
                for (let key in this.formDetail) {
                    for (let dataKey in res.data.data) {
                        if (key == dataKey) {
                            this.formDetail[key] = res.data.data[dataKey]
                        }
                    }
                }
                this.$form("getUserVisitorBuildingDetails", data);
                console.log(this.formDetail);
            })
        },
        Edit(row) {
            this.getUserVisitorBuildingDetails({ yuvbId: row.yuvbId }).result(res => {
                const data = res.data.data;
                for (let key in this.formBuilding) {
                    for (let dataKey in res.data.data) {
                        if (key == dataKey) {
                            this.formBuilding[key] = res.data.data[dataKey]
                        }
                    }
                }
                this.$form("updateUserVisitorBuilding", data)
            })
        },
        myform(submit, Myformdata) {
            console.log(Myformdata);
            for (let key in this.formBuilding) {
                Myformdata[key] = this.formBuilding[key];
                this.formBuilding[key] = '';
            };
            submit();
            console.log(Myformdata);
        },
        bulkImportClick() {
            if (this.tabledata.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.uploadImportVisitorBuilding({
                    sitId: this.tabledata.sitId
                })
                this.$message({
                    type: 'success',
                    message: '导入成功!'
                });
                this.$form("addMultiUsersAll", "hide")
            }

        },
        doupload: async function (file) {
            let param = new FormData(); // 创建form对象
            param.append("file", file); // 通过append向form对象添加数据
            if (this.row && this.row.projectId) {
                param.append("projectId", this.row.projectId);
            }
            console.log(param)
            const loading = $Loading();
            const responseData = await myhttp.postFileUsers("/opportunity/user-visitor-building/uploadUserVisitorBuilding", param);
            loading.close();
            if (responseData.data.result == "success") {
                this.$message({
                    type: "success",
                    message: "上传成功!"
                });
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!"
                });
            }
            return responseData
        },
        async onChangeContent(files, fileList) {
            const table = await this.doupload(files.raw);
            this.tabledata = table.data.data.data.sysImportTem;
            this.tabledataAll = table.data.data.data.resultList;
            //    this.getUserTargetList();
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();  //清空文件
            }
            if (this.$refs.uploadAll) {
                this.$refs.uploadAll.clearFiles();  //清空文件
            }
        },
        toDownExcel() {
            myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/building.xlsx", "楼宇.xlsx");
        },
        theProjectAllChange(e) {
            if (e == '') {
                return this.form.projectId = e;
            }
            this.form.projectId = e;
            this.getUserVisitorBuildingList({ projectId: this.form.projectId })
        },
    },

    created() {
        this.getProjectList({
            pageSize: 0
        });

        this.theProjectId = A.local("$projectId");

        if (this.theProjectId != 0) {
            this.form.projectId = this.theProjectId;
        }
        this.getUserVisitorCustomizeMapList({ projectId: this.theProjectId }).result(res => {
            this.DiyList = res.data.data;
            res.data.data.visitorCustomizeBuilding.forEach(element => {
                if (element.yuvceShow == 2) {
                    this.formBuilding[element.yuvceKey] = '';
                    this.formDetail[element.yuvceKey] = '';
                }

            });
            console.log(this.formBuilding);
        })
        this.getUserVisitorBuildingList({ projectId: this.form.projectId })
        this.getUserVisitorBuildingList();
        this.getUserVisitorPropertyList({ pageSize: 0, yuvpType: 1 });
        this.getUserVisitorBuildingClassList();
    }
};
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/help/building.vue